import { createBooleanQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'
import { useDimension } from './dimension'

export const useShowFramework = createSharedComposable(() => {
    return createBooleanQuery('show-framework', {
        set(value) {
            useDimension().value = undefined
            return value?.toString()
        }
    })
})
